import PortalIdParser from 'PortalIdParser';
export const getCRMEmailLoggingSettingsUrl = () => `/settings/${PortalIdParser.get()}/objects/activities/email-logging`;